import React, { useEffect, useRef } from 'react';

interface VideoPlayerProps {
  stream: MediaStream | null;
  muted?: boolean;
  mirrored?: boolean;
  label?: string;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  stream,
  muted = false,
  mirrored = false,
  label,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  return (
    <div style={styles.container}>
      {label && <div style={styles.label}>{label}</div>}
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted={muted}
        style={{
          ...styles.video,
          transform: mirrored ? 'scaleX(-1)' : 'none',
        }}
      />
      {!stream && (
        <div style={styles.placeholder}>
          <div style={styles.placeholderIcon}>📹</div>
          <p style={styles.placeholderText}>
            {label === 'You' ? 'Your camera' : 'Waiting for partner...'}
          </p>
        </div>
      )}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    backgroundColor: 'var(--color-dark-navy)',
    borderRadius: 'var(--radius-lg)',
    overflow: 'hidden',
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  label: {
    position: 'absolute',
    top: '1rem',
    left: '1rem',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: 'white',
    padding: '0.5rem 1rem',
    borderRadius: 'var(--radius-md)',
    fontSize: '0.9rem',
    fontWeight: '600',
    zIndex: 10,
  },
  placeholder: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--color-dark-navy)',
  },
  placeholderIcon: {
    fontSize: '4rem',
    marginBottom: '1rem',
    opacity: 0.5,
  },
  placeholderText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '1rem',
  },
};
